export default {
    NPCKills: {
        GreenSlime: 1000,
        BlueSlime: 1000,
        Vulture: 1000,
        WindyBalloon: 1000,
        Dandelion: 1000,
        PurpleSlime: 1000,
        Piranha: 1000,
        GreenEye: 1000,
        Firefly: 1000,
        EaterofSouls: 1000,
        DemonEye: 1000,
        Zombie: 1000,
        TorchZombie: 1000,
        CataractEye: 1000,
        FemaleZombie: 1000,
        BigBaldZombie: 1000,
        PincushionZombie: 1000,
        BaldZombie: 1000,
        BlueJellyfish: 1000,
        TwiggyZombie: 1000,
        RedSlime: 1000,
        YellowSlime: 1000,
        Snail: 1000,
        DialatedEye: 1000,
        SquirrelRed: 1000,
        SlimedZombie: 1000,
        FlyingFish: 1000,
        Worm: 1000,
        UmbrellaSlime: 1000,
        JungleBat: 1000,
        SwampZombie: 1000,
        SleepyEye: 1000,
        LarvaeAntlion: 1000,
        SmallBaldZombie: 1000,
        SandSlime: 1000,
        TombCrawlerHead: 1000,
        WalkingAntlion: 1000,
        GiantWormHead: 1000,
        Mouse: 1000,
        GiantFlyingAntlion: 1000,
        FlyingAntlion: 1000,
        Antlion: 1000,
        GiantWalkingAntlion: 1000,
        Dolphin: 1000,
        Crab: 1000,
        SeaTurtle: 1000,
        ZombieRaincoat: 1000,
        SlimeSpiked: 1000,
        KingSlime: 1000,
        Goldfish: 1000,
        Scorpion: 1000,
        PurpleEye: 1000,
        DevourerHead: 1000,
        IceSlime: 1000,
        ZombieEskimo: 1000,
        Bunny: 1000,
        Seagull2: 1000,
        Skeleton: 1000,
        HeadacheSkeleton: 1000,
        MotherSlime: 1000,
        BabySlime: 1000,
        Nymph: 1000,
        Salamander2: 1000,
        Crawdad: 1000,
        PantlessSkeleton: 1000,
        CaveBat: 1000,
        BlackSlime: 1000,
        WallCreeperWall: 1000,
        UndeadMiner: 1000,
        SporeBat: 1000,
        CochinealBeetle: 1000,
        SporeSkeleton: 1000,
        ServantofCthulhu: 1000,
        EyeofCthulhu: 1000,
        Harpy: 1000,
        EaterofWorldsHead: 1000,
        Penguin: 1000,
        Grasshopper: 1000,
        GoblinScout: 1000,
        ChaosBall: 1000,
        GoblinSorcerer: 1000,
        BloodZombie: 1000,
        GoblinWarrior: 1000,
        GoblinArcher: 1000,
        GoblinPeon: 1000,
        GoblinThief: 1000,
        Drippler: 1000,
        TheBride: 1000,
        MeteorHead: 1000,
        JungleSlime: 1000,
        Grubby: 1000,
        HornetStingy: 1000,
        SpikedJungleSlime: 1000,
        Hornet: 1000,
        BeeSmall: 1000,
        Sluggy: 1000,
        Bee: 1000,
        HornetHoney: 1000,
        GreekSkeleton: 1000,
        ManEater: 1000,
        HornetFatty: 1000,
        HornetSpikey: 1000,
        Buggy: 1000,
        LacBeetle: 1000,
        Shark: 1000,
        PinkJellyfish: 1000,
        Frog: 1000,
        Snatcher: 1000,
        HornetLeafy: 1000,
        CorruptGoldfish: 1000,
        FireImp: 1000,
        Hellbat: 1000,
        LavaSlime: 1000,
        VoodooDemon: 1000,
        Demon: 1000,
        Seagull: 1000,
        MisassembledSkeleton: 1000,
        Ghost: 1000,
        Maggot: 1000,
        ZombieMerman: 1000,
        EyeballFlyingFish: 1000,
        SkeletronHand: 1000,
        SkeletronHead: 1000,
        CursedSkull: 1000,
        AngryBones: 1000,
        WaterSphere: 1000,
        DarkCaster: 1000,
        AngryBonesBigMuscle: 1000,
        AngryBonesBig: 1000,
        AngryBonesBigHelmet: 1000,
        DungeonSlime: 1000,
        BoneSerpentHead: 1000,
        Lavafly: 1000,
        BurningSphere: 1000,
        FairyCritterGreen: 1000,
        HellButterfly: 1000,
        MagmaSnail: 1000,
        PenguinBlack: 1000,
        LadyBug: 1000,
        Bird: 1000,
        Squirrel: 1000,
        BirdBlue: 1000,
        VileSpit: 1000,
        QueenBee: 1000,
        Squid: 1000,
        SeaSnail: 1000,
        DD2GoblinT3: 1000,
        DD2GoblinBomberT3: 1000,
        DD2JavelinstT3: 1000,
        DD2WyvernT3: 1000,
        DD2SkeletonT3: 1000,
        DD2DarkMageT3: 1000,
        RedDragonfly: 1000,
        Seahorse: 1000,
        Pinky: 1000,
        Tumbleweed: 1000,
        Tim: 1000,
        TheHungry: 1000,
        TheHungryII: 1000,
        LeechHead: 1000,
        WallofFlesh: 1000,
        Pixie: 1000,
        GiantTortoise: 1000,
        Derpling: 1000,
        Arapaima: 1000,
        ToxicSludge: 1000,
        GreenJellyfish: 1000,
        DiggerHead: 1000,
        IlluminantBat: 1000,
        AnglerFish: 1000,
        SkeletonArcher: 1000,
        IlluminantSlime: 1000,
        ArmoredSkeleton: 1000,
        PossessedArmor: 1000,
        Wraith: 1000,
        AngryNimbus: 1000,
        Corruptor: 1000,
        CorruptSlime: 1000,
        Slimeling: 1000,
        DuneSplicerHead: 1000,
        BlackRecluseWall: 1000,
        LightMummy: 1000,
        Unicorn: 1000,
        WyvernHead: 1000,
        WanderingEye: 1000,
        IceElemental: 1000,
        Probe: 1000,
        IceBat: 1000,
        IceTortoise: 1000,
        ArmoredViking: 1000,
        SpikedIceSlime: 1000,
        GiantBat: 1000,
        IcyMerman: 1000,
        UndeadViking: 1000,
        SnowFlinx: 1000,
        CyanBeetle: 1000,
        IceMimic: 1000,
        ShadowFlameApparition: 1000,
        GoblinSummoner: 1000,
        Slimer: 1000,
        IceGolem: 1000,
        Mummy: 1000,
        AngryTrapper: 1000,
        JungleCreeperWall: 1000,
        Medusa: 1000,
        MossHornet: 1000,
        Mimic: 1000,
        DemonTaxCollector: 1000,
        RockGolem: 1000,
        SeekerHead: 1000,
        ChaosElemental: 1000,
        EnchantedSword: 1000,
        Werewolf: 1000,
        FaceMonster: 1000,
        Crimslime: 1000,
        Crimera: 1000,
        Herpling: 1000,
        FloatyGross: 1000,
        BigMimicCorruption: 1000,
        IchorSticker: 1000,
        Clinger: 1000,
        CursedHammer: 1000,
        BloodJelly: 1000,
        BloodFeeder: 1000,
        BigMimicCrimson: 1000,
        Clown: 1000,
        TheGroom: 1000,
        PirateDeckhand: 1000,
        PirateCrossbower: 1000,
        PirateCorsair: 1000,
        Parrot: 1000,
        PirateDeadeye: 1000,
        PirateCaptain: 1000,
        PirateGhost: 1000,
        PirateShipCannon: 1000,
        PirateShip: 1000,
        DesertGhoul: 1000,
        DesertLamiaLight: 1000,
        DesertBeast: 1000,
        DesertGhoulHallow: 1000,
        DesertScorpionWall: 1000,
        Pirate: 1000,
        ChatteringTeethBomb: 1000,
        Butterfly: 1000,
        Raven: 1000,
        GiantFlyingFox: 1000,
        Wolf: 1000,
        Angler: 1000,
        GoblinShark: 1000,
        Clothier: 1000,
        Spazmatism: 1000,
        Retinazer: 1000,
        DD2KoboldWalkerT3: 1000,
        DD2DrakinT3: 1000,
        DD2KoboldFlyerT3: 1000,
        DD2WitherBeastT3: 1000,
        DD2OgreT3: 1000,
        TheDestroyer: 1000,
        SkeletronPrime: 1000,
        PrimeLaser: 1000,
        PrimeSaw: 1000,
        AnomuraFungus: 1000,
        TruffleWorm: 1000,
        MushiLadybug: 1000,
        GiantFungiBulb: 1000,
        FungiSpore: 1000,
        GlowingSnail: 1000,
        BirdRed: 1000,
        Gnome: 1000,
        FungiBulb: 1000,
        ZombieMushroomHat: 1000,
        QueenSlimeMinionPink: 1000,
        QueenSlimeMinionPurple: 1000,
        QueenSlimeMinionBlue: 1000,
        QueenSlimeBoss: 1000,
        Gastropod: 1000,
        Owl: 1000,
        RainbowSlime: 1000,
        Moth: 1000,
        DoctorBones: 1000,
        SandShark: 1000,
        SandElemental: 1000,
        Pupfish: 1000,
        Spore: 1000,
        PlanterasTentacle: 1000,
        Plantera: 1000,
        BlueArmoredBonesMace: 1000,
        BlueArmoredBonesSword: 1000,
        HellArmoredBonesSpikeShield: 1000,
        NecromancerArmored: 1000,
        BlueArmoredBonesNoPants: 1000,
        BlueArmoredBones: 1000,
        SkeletonCommando: 1000,
        BoneLee: 1000,
        DungeonSpirit: 1000,
        HellArmoredBonesMace: 1000,
        GiantCursedSkull: 1000,
        HellArmoredBones: 1000,
        HellArmoredBonesSword: 1000,
        Necromancer: 1000,
        RustyArmoredBonesSwordNoArmor: 1000,
        Paladin: 1000,
        FairyCritterPink: 1000,
        RaggedCasterOpenCoat: 1000,
        SkeletonSniper: 1000,
        RustyArmoredBonesAxe: 1000,
        DiabolistWhite: 1000,
        RustyArmoredBonesFlail: 1000,
        ZombieMushroom: 1000,
        GingerbreadMan: 1000,
        ZombieElfGirl: 1000,
        ZombieElf: 1000,
        ZombieElfBeard: 1000,
        PresentMimic: 1000,
        ElfArcher: 1000,
        Everscream: 1000,
        NutcrackerSpinning: 1000,
        ElfCopter: 1000,
        SantaNK1: 1000,
        Krampus: 1000,
        Lavabat: 1000,
        GraniteGolem: 1000,
        GraniteFlyer: 1000,
        Scarecrow2: 1000,
        Scarecrow3: 1000,
        Scarecrow9: 1000,
        Scarecrow1: 1000,
        Scarecrow8: 1000,
        Scarecrow7: 1000,
        Scarecrow10: 1000,
        Scarecrow5: 1000,
        Scarecrow6: 1000,
        Scarecrow4: 1000,
        Splinterling: 1000,
        Hellhound: 1000,
        MourningWood: 1000,
        Poltergeist: 1000,
        Pumpking: 1000,
        RuneWizard: 1000,
        BloodEelHead: 1000,
        BloodNautilus: 1000,
        BloodSquid: 1000,
        EmpressButterfly: 1000,
        Nurse: 1000,
        TravellingMerchant: 1000,
        DD2Bartender: 1000,
        Golfer: 1000,
        HallowBoss: 1000,
        LihzahrdCrawler: 1000,
        FlyingSnake: 1000,
        GolemFistLeft: 1000,
        GolemFistRight: 1000,
        GolemHead: 1000,
        Golem: 1000,
        TacticalSkeleton: 1000,
        RustyArmoredBonesSword: 1000,
        DiabolistRed: 1000,
        DD2LightningBugT3: 1000,
        HeadlessHorseman: 1000,
        SlimeMasked: 1000,
        DemonEyeOwl: 1000,
        ZombiePixie: 1000,
        DemonEyeSpaceship: 1000,
        ZombieSuperman: 1000,
        HoppinJack: 1000,
        ZombieDoctor: 1000,
        Flocko: 1000,
        IceQueen: 1000,
        Yeti: 1000,
        Merchant: 1000,
        SlimeRibbonGreen: 1000,
        SlimeRibbonRed: 1000,
        SlimeRibbonWhite: 1000,
        SlimeRibbonYellow: 1000,
        SwampThing: 1000,
        Reaper: 1000,
        Frankenstein: 1000,
        Vampire: 1000,
        Fritz: 1000,
        ThePossessed: 1000,
        Mothron: 1000,
        DeadlySphere: 1000,
        Butcher: 1000,
        CreatureFromTheDeep: 1000,
        DrManFly: 1000,
        Eyezor: 1000,
        Nailhead: 1000,
        MothronEgg: 1000,
        MothronSpawn: 1000,
        WaterStrider: 1000,
        Psycho: 1000,
        Duck2: 1000,
        ZombieSweater: 1000,
        BunnySlimed: 1000,
        GoldBunny: 1000,
        SnowmanGangsta: 1000,
        MisterStabby: 1000,
        SnowBalla: 1000,
        GigaZapper: 1000,
        MartianDrone: 1000,
        ForceBubble: 1000,
        MartianOfficer: 1000,
        ScutlixRider: 1000,
        Scutlix: 1000,
        RayGunner: 1000,
        GrayGrunt: 1000,
        BrainScrambler: 1000,
        MartianWalker: 1000,
        MartianEngineer: 1000,
        MartianTurret: 1000,
        MartianSaucerCannon: 1000,
        MartianSaucerTurret: 1000,
        MartianSaucerCore: 1000,
        CultistArcherBlue: 1000,
        CultistDevote: 1000,
        CultistBoss: 1000,
        NebulaHeadcrab: 1000,
        NebulaBeast: 1000,
        NebulaSoldier: 1000,
        NebulaBrain: 1000,
        LunarTowerNebula: 1000,
        StardustSoldier: 1000,
        StardustWormHead: 1000,
        StardustJellyfishBig: 1000,
        StardustSpiderBig: 1000,
        StardustCellBig: 1000,
        StardustCellSmall: 1000,
        StardustSpiderSmall: 1000,
        LunarTowerStardust: 1000,
        SolarGoop: 1000,
        SolarCrawltipedeHead: 1000,
        SolarCorite: 1000,
        SolarSroller: 1000,
        SolarDrakomire: 1000,
        SolarFlare: 1000,
        SolarSolenian: 1000,
        SolarDrakomireRider: 1000,
        SolarSpearman: 1000,
        LunarTowerSolar: 1000,
        VortexHornet: 1000,
        VortexSoldier: 1000,
        VortexHornetQueen: 1000,
        VortexLarva: 1000,
        VortexRifleman: 1000,
        LunarTowerVortex: 1000,
        MoonLordCore: 1000,
        RaggedCaster: 1000,
        DukeFishron: 1000,
        DD2Betsy: 1000,
        BigMimicHallow: 1000,
        FairyCritterBlue: 1000,
        ExplosiveBunny: 1000,
        BunnyXmas: 1000,
        CultistDragonHead: 1000,
        AncientLight: 1000,
        Sharkron: 1000,
        Creeper: 1000,
        BrainofCthulhu: 1000,
        ZombieXmas: 1000,
        CorruptBunny: 1000,
        CorruptPenguin: 1000,
        MartianProbe: 1000,
        CrimsonBunny: 1000,
        BloodCrawlerWall: 1000,
        CrimsonPenguin: 1000,
        CrimsonGoldfish: 1000,
        RedDevil: 1000,
        AncientCultistSquidhead: 1000,
        MaggotZombie: 1000,
        SkeletonTopHat: 1000,
        SkeletonAstonaut: 1000,
        SkeletonAlien: 1000,
        TruffleWormDigger: 1000,
        FungoFish: 1000,
        DarkMummy: 1000,
        BloodMummy: 1000,
        PigronCrimson: 1000,
        PigronHallow: 1000,
        PigronCorruption: 1000,
        DesertDjinn: 1000,
        DesertGhoulCrimson: 1000,
        DesertGhoulCorruption: 1000,
        DesertLamiaDark: 1000,
        CrimsonAxe: 1000,
        PartyBunny: 1000,
        SandsharkCorrupt: 1000,
        SandsharkHallow: 1000,
        SandsharkCrimson: 1000,
        LightningBug: 1000
    },
    NPCSights: [
        "SquirrelRed",
        "Bird",
        "Grasshopper",
        "RedDragonfly",
        "BirdRed",
        "Turtle",
        "Frog",
        "Firefly",
        "Owl",
        "Butterfly",
        "Bunny",
        "Snail",
        "Goldfish",
        "Worm",
        "Buggy",
        "Mouse",
        "ScorpionBlack",
        "Squirrel",
        "DuckWhite2",
        "Seagull2",
        "Seagull",
        "Dolphin",
        "SeaTurtle",
        "Scorpion",
        "DuckWhite",
        "LadyBug",
        "BirdBlue",
        "Pupfish",
        "Penguin",
        "PenguinBlack",
        "EnchantedNightcrawler",
        "Grubby",
        "TurtleJungle",
        "Sluggy",
        "FairyCritterPink",
        "FairyCritterBlue",
        "HellButterfly",
        "Seahorse",
        "Grebe2",
        "Maggot",
        "MagmaSnail",
        "Lavafly",
        "GoldBunny",
        "PartyBunny",
        "DD2LanePortal",
        "FairyCritterGreen",
        "Duck2",
        "Rat",
        "WaterStrider",
        "TruffleWorm",
        "TruffleWormDigger",
        "GlowingSnail",
        "Grebe",
        "EmpressButterfly",
        "GemBunnyEmerald",
        "GemBunnyTopaz",
        "GemSquirrelTopaz",
        "GemSquirrelAmber",
        "GemBunnyAmber",
        "GemBunnySapphire",
        "GemBunnyAmethyst",
        "GemSquirrelEmerald",
        "GemSquirrelDiamond",
        "GemBunnyRuby",
        "GemSquirrelAmethyst",
        "GemSquirrelRuby",
        "GemSquirrelSapphire",
        "GemBunnyDiamond",
        "GoldWorm",
        "BunnySlimed",
        "BunnyXmas",
        "GoldDragonfly",
        "ExplosiveBunny",
        "Duck",
        "LightningBug"
    ],
    NPCChats: [
        "Guide",
        "TravellingMerchant",
        "Merchant",
        "SleepingAngler",
        "Angler",
        "Demolitionist",
        "BestiaryGirl",
        "WebbedStylist",
        "Stylist",
        "BartenderUnconscious",
        "DD2Bartender",
        "ArmsDealer",
        "Dryad",
        "Painter",
        "TownCat",
        "OldMan",
        "Clothier",
        "BoundMechanic",
        "Mechanic",
        "PartyGirl",
        "DyeTrader",
        "BoundGoblin",
        "GoblinTinkerer",
        "WitchDoctor",
        "SkeletonMerchant",
        "GolferRescue",
        "Golfer",
        "Nurse",
        "BoundWizard",
        "Wizard",
        "Pirate",
        "TaxCollector",
        "TownBunny",
        "Steampunker",
        "Truffle",
        "Cyborg",
        "SantaClaus",
        "TownDog"
    ]
}